
























































































import { CountryPayload } from "../types";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import DocumentSvg from "@/components/svg/DocumentsSvg.vue";
import ChooseCountrySvg from "@/modules/document/components/ChooseCountrySvg.vue";
import ChooseCountryDesktopSvg from "@/modules/document/components/ChooseCountryDesktopSvg.vue";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";
import { getCountries } from "@/utils/countries";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";

const Document = namespace("document");

Vue.component("v-select", vSelect);

@Component({
  components: {
    "document-svg": DocumentSvg,
    "previous-page-arrow": PreviousPageArrow,
    "choose-country-svg": ChooseCountrySvg,
    "choose-country-desktop-svg": ChooseCountryDesktopSvg,
  },
})
export default class ChooseDocument extends Vue {
  @Document.Action("updateCountry") updateCountry!: (
    payload: CountryPayload
  ) => void;
  isSelected = false;
  isDropDownActive = false;
  countries = [];
  async mounted() {
    this.countries = await getCountries();

    if (Vue.prototype.$useAudioInstructions) {
      await Vue.prototype.$audioConfigs.playChooseCountry();
    }
  }

  beforeUnmount() {
    if (Vue.prototype.$useAudioInstructions) {
      Vue.prototype.$audioConfigs.stopChooseCountry();
    }
  }

  handleChange(selected) {
    if (selected) {
      this.updateCountry({
        country: selected.name,
        countryCode: selected.code,
        supportedDocuments: selected.supportedDocuments,
      });
      this.isSelected = true;
    } else {
      this.isSelected = false;
    }
  }
  handleFocus() {
    this.isDropDownActive = true;
  }
  handleBlur() {
    this.isDropDownActive = false;
  }

  goToChooseDocument() {
    this.sendChoseCountry();
    this.$router.push({
      name: "chooseDocument",
      query: this.$route.query, // preserve query params if needed
    });
  }

  sendChoseCountry() {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");
    const magicLink = params.get("magic");
    const progressionStep = 5;

    if ((publicKey && applicantId) || magicLink) {
      axios.put(
        `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/verification-progress-step`,
        {
          publicKey,
          progressionStep,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
  }
}
